import { api } from './api'

// Serialize list options into the /text-searches query string. Like Global AI
// chats, a saved search has no facets - only free-text `q`, `sort`, and keyset
// pagination.
function buildQuery({ q, cursor, limit, sort } = {}) {
  const params = new URLSearchParams()
  if (q) params.set('q', q)
  if (cursor) params.set('cursor', cursor)
  if (limit) params.set('limit', String(limit))
  if (sort) params.set('sort', sort)
  const query = params.toString()
  return query ? `?${query}` : ''
}

// The current user's saved searches (first/keyset page).
export function listTextSearches(options = {}) {
  return api.get(`/text-searches${buildQuery(options)}`).then((data) => data.searches)
}

// A single saved search by id (used to rehydrate grid windows on reload).
export function getTextSearch(id) {
  return api.get(`/text-searches/${id}`).then((data) => data.search)
}

// Create a saved search. Expects { name, findRules?, findRuleLogic?, ... }.
export function createTextSearch(payload) {
  return api.post('/text-searches', payload).then((data) => data.search)
}

// Update a saved search (name and/or rules). Resolves to the updated search.
export function updateTextSearch(id, payload) {
  return api.patch(`/text-searches/${id}`, payload).then((data) => data.search)
}

// Delete a saved search. Resolves to the deleted search.
export function deleteTextSearch(id) {
  return api.del(`/text-searches/${id}`).then((data) => data.search)
}

// Run a (possibly unsaved) rule set. If `payload.standard` is provided, results
// are scoped to that document; `payload.pageRange` optionally narrows to a slice.
// Otherwise the whole corpus is searched. Returns the full payload:
// { results, nextCursor, hasMore }.
export function runTextSearch(payload) {
  return api.post('/text-searches/search', payload)
}
